/*
 * bladeから設定情報取得用mixin
 */
<script>
export default {
	mixins: [
		// message
		require('js/common/SetMessages.mixin.vue'),
		// manager
		require('js/common/vuex/manager/write.mixin.vue'),
		// setting
		require('js/common/vuex/setting/write.mixin.vue'),
	],
	created:function(){
		this.$on("create_dialog",this.setOverFlow(true));
		this.$on("close_dialog",this.setOverFlow(false));
	},
	
	methods: {
		//! 設定
		setSettings: function( settings ) {

			const replaceChars = [
				{strOld: /\r?\n/g, strNew: "\\n"}, // new line
				{strOld: /\\/g, strNew: "\\\\"}, // back slash
				{strOld: /\"/g, strNew: "\\\""}, // double quot
			];

			replaceChars.forEach(function(row) {
				settings = settings.replace(row.strOld, row.strNew);
			});

			var settings = JSON.parse( this.htmlEntities( settings, 'decode' ) );
			// var settings = $("<div/>").html( settings ).text();
			
			this.setSettingParam(settings);
		},
		/*
		 * 設定の初期化イベント
		 */
		onLoadSetting: function() {
			// Manager 初期化
			this.initManager(this.$refs.mgr);

			// Body に 初期化イベントを発行
			this.$refs.body.onInitialize();
		},
		setOverFlow: function(is) {
			console.log("setOverFlow:"+is);
		},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/main.mixin.vue